import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { MenuService } from 'src/app/services/menu.service';
import { SharedServiceService } from 'src/app/services/shared-service.service';

@Component({
  selector: 'app-quicklinks',
  templateUrl: './quicklinks.component.html',
  styleUrls: ['./quicklinks.component.css']
})
export class QuicklinksComponent implements ICellRendererAngularComp {
  isEditVisible: boolean = true;
  params: any;
  gridApi: any;
  menuData: any[] = [];
  tcConfigurationMenuIsDisplay: any;
  constructor(
    private router: Router,
    private sharedService: SharedServiceService,
    private localStorage: LocalStorageService,
    private menuService: MenuService,
  ) { }

  refresh(): boolean {
    return false;
  }

  agInit(params: any) {
    this.menuService.menu.subscribe(menudata => {
      if (menudata && menudata.length > 0) {
        this.menuData = menudata;
       
     
      }
    });
    this.params = params;
    this.gridApi = params.api;
    this.isEditVisible = !params.data.IsLock;
    //this.isEditVisible=!params.data.IsLock && params.data.IsEditable
    if (params.data.Id == 0)
      this.isEditVisible = false;
    if(!params.data.IsLock)
    {
if (params?.colDef?.field === "eq" && this.menuData.some(x => x.Route === "tc-eq" && x.RoleId!=null)
||
params?.colDef?.field === "cs" && this.menuData.some(x => x.Route === "tc-cs" && x.RoleId!=null) ||
params?.colDef?.field === "scm" && this.menuData.some(x => x.Route === "tc-scm" && x.RoleId!=null)||
params?.colDef?.field === "lc" && this.menuData.some(x => x.Route === "tc-localcosts" && x.RoleId!=null)||
params?.colDef?.field === "inv" && this.menuData.some(x => x.Route === "tc-investmentplan" && x.RoleId!=null) ||
params?.colDef?.field === "tdc" && this.menuData.some(x => x.Route === "plc-tc-directcost" && x.RoleId!=null)||
params?.colDef?.field === "plc" && this.menuData.some(x => x.Route === "plc-tc-summary" && x.RoleId!=null)) {
  this.isEditVisible = true
}

else

this.isEditVisible = false
    }

  //   if (params.data.AccessRoleID == 7 && !params.data.IsLock) {
  //     if ((params.colDef.field == "eq") || (params.colDef.field == "inv")) {
  //       this.isEditVisible = true
  //     }
  //     else {
  //       this.isEditVisible = false
  //     }

  //   }
  //   if (params.data.AccessRoleID == 6 && !params.data.IsLock) {
  //     if (params.colDef.field == "cs" || params.colDef.field == "inv") {
  //       this.isEditVisible = true
  //     }
  //     else {
  //       this.isEditVisible = false
  //     }
  //   }
  //   if(params.data.AccessRoleID==1 && !params.data.IsLock)
  //   {
  //   if (params.colDef.field == "eq" || params.colDef.field == "cs"||params.colDef.field == "scm"||params.colDef.field == "lc"||
  //   params.colDef.field == "inv"||
  //   params.colDef.field == "tdc"||
  //   params.colDef.field == "plc")
  //    {
  //     this.isEditVisible = true
  //   }
  //   else {
  //     this.isEditVisible = false
  //   }
  // }

  }

  goToPage(params) {
    this.sharedService.changeConfigId(0);
    this.localStorage.set("ConfigId", params.data.Id);

    if (params.colDef.field == "eq") {
      this.router.navigate(["/tc-eq"]);
    }


    if (params.colDef.field == "cs") {
      this.router.navigate(["/tc-cs"]);
    }//}
    if (params.colDef.field == "scm") {
      this.router.navigate(["/tc-scm"]);
    }
    if (params.colDef.field == "lc") {
      this.router.navigate(["/tc-localcosts"]);
    }
    if (params.colDef.field == "inv") {
      this.router.navigate(["/tc-investmentplan"]);
    }
    if (params.colDef.field == "tdc") {
      this.router.navigate(["/plc-tc-directcost"]);
    }
    if (params.colDef.field == "plc") {
      this.router.navigate(["/plc-tc-summary"]);
    }
  }
}
